import React, { Component } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { darkTheme, defaultTheme, highConstrastDefaultTheme, highConstrastDarkTheme } from './theme';
import { MainLayout } from './layouts';
import { RouteWithLayout } from './components';

const Agree = React.lazy(() => import('./pages/Agree'));
const Consent = React.lazy(() => import('./pages/Consent'));
const SpecialTerms = React.lazy(() => import('./pages/SpecialTerms'));
const ChildSpecialTerm = React.lazy(() => import('./pages/SpecialTerms/ChildSpecialTerm'));
const Notice = React.lazy(() => import('./pages/Notice'));
const ErrorPage = React.lazy(() => import('./pages/Error'));
const TermDetails = React.lazy(() => import('./pages/TermDetails'));

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

class App extends Component {

  render() {
    const urlSearch = new URLSearchParams(window.location.search);
    const darkMode = urlSearch.get("darkMode") === "true";
    const isHighContrastFonts = urlSearch.get("isHighContrastFonts") === "true";
    let theme = defaultTheme;
    if (darkMode) {
      if (isHighContrastFonts) {
        theme = highConstrastDarkTheme;
      } else {
        theme = darkTheme;
      }
    } else if (isHighContrastFonts) {
      theme = highConstrastDefaultTheme;
    }
    
    return (
      <ThemeProvider theme={theme}>
        <Router>
          <React.Suspense fallback={loading}>
            <Switch>
              <RouteWithLayout exact layout={MainLayout} path="/agree" component={Agree} />
              <RouteWithLayout exact layout={MainLayout} path="/terms" component={Consent} />
              <RouteWithLayout exact layout={MainLayout} path="/terms/special" component={SpecialTerms} />
              <RouteWithLayout exact layout={MainLayout} path="/terms/:consentId" component={Consent} />
              <RouteWithLayout exact layout={MainLayout} path="/terms/details/:consentId" component={TermDetails} />
              <RouteWithLayout exact layout={MainLayout} path="/terms/special/:appKey" component={ChildSpecialTerm} />
              <RouteWithLayout exact layout={MainLayout} path="/notice" component={Notice} />
              <RouteWithLayout exact layout={MainLayout} path="/notice/:noticeId" component={Notice} />
              <RouteWithLayout layout={MainLayout} component={ErrorPage} />
            </Switch>
          </React.Suspense>
        </Router>
      </ThemeProvider>
    );
  }
}

export default App;
